import { render } from "./SessionExpiredView.vue?vue&type=template&id=61aeff4e"
import script from "./SessionExpiredView.vue?vue&type=script&lang=js"
export * from "./SessionExpiredView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__